import { Flex } from '@chakra-ui/react';
import { Role } from '@texas/api/endpoints/userApi';
import { BodyOverride } from '@texas/components/shared/BodyOverride';
import { TexasHeader } from '@texas/components/shared/TexasHeader';
import { useActiveSession } from '@texas/hooks/useSession';
import { hasRole } from '@texas/utils/helpers/roleHelpers';
import { createContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigSection } from './ConfigSection';
import { TableSection } from './TableSection';
import { useVdcConfiguration } from './useVdcConfiguration';

export const VdcConfigContext = createContext<ReturnType<
  typeof useVdcConfiguration
> | null>(null);

export function VdcPricing() {
  const { t } = useTranslation();
  const session = useActiveSession();

  if (
    !hasRole(session.currentUser.role, [
      Role.InternalAdministrator,
      Role.SystemAdministrator,
    ])
  ) {
    return null;
  }

  return (
    <BodyOverride>
      <Flex direction="column" gap={4}>
        <TexasHeader text={t('vdc.title')} />
        <Inner />
      </Flex>
    </BodyOverride>
  );
}

function Inner() {
  const contextValue = useVdcConfiguration();

  return (
    <VdcConfigContext.Provider value={contextValue}>
      <Flex gap={8} align="flex-start">
        <ConfigSection />
        <TableSection />
      </Flex>
    </VdcConfigContext.Provider>
  );
}
